import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const Card = styled.div`
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 28px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    font-family: "Inter", system-ui, sans-serif;
`;

const Avatar = styled.div`
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #6366f1;
    color: #fff;
    font-size: 1.4rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const Email = styled.div`
    font-size: 0.875rem;
    font-weight: 600;
    color: #0f172a;
    text-align: center;
    word-break: break-all;
`;

const Label = styled.div`
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-weight: 600;
`;

function initials(email = "") {
    const name = email.split("@")[0] || "?";
    return name.slice(0, 2).toUpperCase();
}

export const UserDetails = () => {
    const username = useSelector((s) => s.login.userDetails.username) || "";

    return (
        <Card>
            <Avatar>{initials(username)}</Avatar>
            <div style={{ textAlign: "center" }}>
                <Label>Account</Label>
                <Email>{username}</Email>
            </div>
        </Card>
    );
};
